 <template>
  <v-container fluid full-height grid-list-md>
    <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="onSave">
      <v-layout row wrap>
        <v-flex xs6>
          <div class="text-xs-left">
            <v-breadcrumbs :items="breadcrumbs" divider=">">
              <template slot="item" slot-scope="props">
                <router-link
                  :to="'/' + props.item.to"
                  :disabled="props.item.disabled"
                  v-bind:class="{
                    'v-breadcrumbs__item v-breadcrumbs__item--disabled':
                      props.item.disabled,
                  }"
                  >{{ props.item.text }}</router-link
                >
              </template>
            </v-breadcrumbs>
          </div>
        </v-flex>
        <v-flex xs6>
          <div class="text-xs-right">
            <v-btn outline color="primary" @click="goBack">
              Go Back
              <v-icon right>arrow_back</v-icon>
            </v-btn>
          </div>
        </v-flex>
        <v-flex>
          <v-card>
            <v-layout row wrap class="pa-3">
              <v-flex sm12 v-if="responseError">
                <span class="red--text">{{ responseError }}</span>
              </v-flex>
              <v-flex sm6>
                <v-menu
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    label="Ledger Entry Date"
                    type="text"
                    :disabled="status != 'DRAFT' ? true : false"
                    prepend-icon="event"
                    v-model="ledgerDate"
                  ></v-text-field>
                  <v-date-picker
                    :disabled="status != 'DRAFT' ? true : false"
                    v-model="ledgerDate"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm6>
                <v-text-field
                  label="Description"
                  type="text"
                  class="mr-1"
                  :disabled="status != 'DRAFT' ? true : false"
                  v-model="generalLedger.description"
                ></v-text-field>
              </v-flex>
              <v-flex sm6>
                <v-text-field
                  label="Choose Shop..."
                  v-model="shopCode"
                  @click="showShops()"
                  class="mr-2"
                  :disabled="status != 'DRAFT' ? true : false"
                  :rules="[() => !!shopCode || 'Shop is required.']"
                ></v-text-field>
              </v-flex>
              <v-flex sm6>
                <v-autocomplete
                  v-model="generalLedger.currencyId"
                  :items="currencyList"
                  color="blue-grey lighten-2"
                  label="Choose Currency..."
                  item-text="code"
                  menu-props="auto"
                  :disabled="status != 'DRAFT' ? true : false"
                  item-value="id"
                  :rules="[
                    () => !!generalLedger.currencyId || 'Currency is required.',
                  ]"
                ></v-autocomplete>
              </v-flex>
              <v-flex sm6>
                <v-text-field
                  label="Invoice No"
                  type="text"
                  class="mr-1"
                  :disabled="status != 'DRAFT' ? true : false"
                  v-model="generalLedger.invoiceNo"
                ></v-text-field>
              </v-flex>
              <v-flex sm6>
                <v-text-field
                  label="Cheque No"
                  type="text"
                  class="mr-1"
                  :disabled="status != 'DRAFT' ? true : false"
                  v-model="generalLedger.chequeNo"
                ></v-text-field>
              </v-flex>
              <v-flex sm6>
                <v-text-field
                  label="Reference"
                  type="text"
                  class="mr-1"
                  :disabled="status != 'DRAFT' ? true : false"
                  v-model="generalLedger.reference"
                ></v-text-field>
              </v-flex>
              <v-flex sm6>
                <v-text-field
                  label="Ledger By"
                  type="text"
                  class="mr-1"
                  readonly
                  v-model="ledgerByName"
                ></v-text-field>
              </v-flex>
              <v-flex sm6 v-if="generalLedger.id">
                <v-autocomplete
                  v-model="generalLedger.status"
                  :items="statusList"
                  color="blue-grey lighten-2"
                  label="Choose Status..."
                  item-text="label"
                  item-value="value"
                  :disabled="status != 'DRAFT' ? true : false"
                  :rules="[
                    () => !!generalLedger.status || 'Status is required.',
                  ]"
                ></v-autocomplete>
              </v-flex>
              <v-flex sm12>
                <v-flex sm12>
                  <v-label>Attach File</v-label>
                  <input
                    type="file"
                    id="files"
                    ref="files"
                    v-on:change="onChangeFileUpload"
                    multiple
                    accept=".pdf, .png, .jpg, .jpeg, .docx, .xlsx"
                  />
                </v-flex>
                <v-flex sm12>
                  <div
                    v-for="(
                      generalLedgerAttachment, key
                    ) in generalLedgerAttachments"
                    :key="key"
                  >
                    <a
                      v-text="generalLedgerAttachment.fileName"
                      @click.prevent="downloadFile(generalLedgerAttachment)"
                    />
                    <span v-if="generalLedger.id">
                      <v-btn
                        icon
                        @click="removeFile(key, generalLedgerAttachment.id)"
                      >
                        <v-icon color="red">cancel</v-icon>
                      </v-btn>
                    </span>
                  </div>
                </v-flex>
              </v-flex>
              <v-flex sm12>
                <v-layout row wrap>
                  <v-btn color="success" @click="addDebitAccount()">
                    Add Debit Account
                    <v-icon right>add</v-icon>
                  </v-btn>
                  <v-flex sm3 offset-sm1>
                    <span class="font-weight-black">Total Debit :</span>
                    <v-chip>
                      <span class="font-weight-black">{{
                        totalDebitAmount | decFormat(6)
                      }}</span>
                    </v-chip>
                  </v-flex>
                  <v-flex sm3>
                    <span class="font-weight-black">Total Credit :</span>
                    <v-chip>
                      <span class="font-weight-black">{{
                        totalCreditAmount | decFormat(6)
                      }}</span>
                    </v-chip>
                  </v-flex>
                </v-layout>
                <v-layout
                  row
                  wrap
                  class="light--text"
                  v-if="generalLedger.generalLedgerDetailList.length > 0"
                >
                  <v-flex xs3>Debit Code</v-flex>
                  <v-flex xs4>Debit Account Name</v-flex>
                  <v-flex xs3>Amount</v-flex>
                  <v-flex xs1>Action</v-flex>
                </v-layout>
                <v-layout
                  row
                  wrap
                  v-for="(
                    generalLedgerDetail, index
                  ) in generalLedger.generalLedgerDetailList"
                  :key="index"
                >
                  <v-layout
                    row
                    wrap
                    v-if="generalLedgerDetail.accountType == 'DEBIT'"
                  >
                    <v-flex xs3>
                      <v-text-field
                        placeholder="Enter Debit Code"
                        v-model="generalLedgerDetail.code"
                        @click="showDebitAccountList(), (selectedIndex = index)"
                        :rules="rules.codeRules"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs4>
                      <v-text-field
                        v-model="generalLedgerDetail.accountName"
                        :loading="showAutocompleteLoading"
                        label="Name"
                        :readonly="true"
                        :rules="rules.nameRules"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs3>
                      <v-text-field
                        v-model="generalLedgerDetail.amount"
                        :loading="showAutocompleteLoading"
                        @input="calculateAmount"
                        label="Amount"
                        :rules="rules.amountRule"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs1>
                      <v-btn
                        icon
                        @click="removeGLDetail(index, generalLedgerDetail.id)"
                      >
                        <v-icon>cancel</v-icon>
                      </v-btn>
                    </v-flex>
                  </v-layout>
                </v-layout>
              </v-flex>
              <v-flex sm12>
                <v-layout row wrap>
                  <v-btn color="success" @click="addCreditAccount()">
                    Add Credit Account
                    <v-icon right>add</v-icon>
                  </v-btn>
                </v-layout>
                <v-layout
                  row
                  wrap
                  class="light--text"
                  v-if="generalLedger.generalLedgerDetailList.length > 0"
                >
                  <v-flex xs3>Credit Code</v-flex>
                  <v-flex xs4>Credit Account Name</v-flex>
                  <v-flex xs3>Amount</v-flex>
                  <v-flex xs1>Action</v-flex>
                </v-layout>
                <v-layout
                  v-for="(
                    generalLedgerDetail, index
                  ) in generalLedger.generalLedgerDetailList"
                  :key="index"
                >
                  <v-layout
                    row
                    wrap
                    v-if="generalLedgerDetail.accountType == 'CREDIT'"
                  >
                    <v-flex xs3>
                      <v-text-field
                        placeholder="Enter Debit Code"
                        v-model="generalLedgerDetail.code"
                        @click="
                          showCreditAccountList(), (selectedIndex = index)
                        "
                        :rules="rules.codeRules"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs4>
                      <v-text-field
                        v-model="generalLedgerDetail.accountName"
                        :loading="showAutocompleteLoading"
                        label="Name"
                        :readonly="true"
                        :rules="rules.nameRules"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs3>
                      <v-text-field
                        v-model="generalLedgerDetail.amount"
                        :loading="showAutocompleteLoading"
                        @input="calculateAmount"
                        label="Amount"
                        :rules="rules.amountRule"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs1>
                      <v-btn
                        icon
                        @click="removeGLDetail(index, generalLedgerDetail.id)"
                      >
                        <v-icon>cancel</v-icon>
                      </v-btn>
                    </v-flex>
                  </v-layout>
                </v-layout>
              </v-flex>
              <v-flex sm12>
                <div class="text-xs-center">
                  <v-btn
                    color="error"
                    @click="clear"
                    :disabled="status != 'DRAFT' ? true : false"
                  >
                    Reset
                    <v-icon right>clear</v-icon>
                  </v-btn>
                  <v-btn
                    type="submit"
                    color="primary"
                    :loading="saveLoading"
                    :disabled="status != 'DRAFT' ? true : false && !valid"
                  >
                    Save
                    <v-icon right>save</v-icon>
                  </v-btn>
                </div>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
    </v-form>

    <!-- shop list dialog-->
    <v-dialog v-model="showShopListDialog" scrollable max-width="1000px">
      <v-card>
        <v-card-title>
          <v-layout wrap>
            <v-flex sm4>
              <v-text-field
                name="code"
                label="Code"
                type="text"
                class="mr-1"
                v-model="shopQueryParams.code"
              ></v-text-field>
            </v-flex>
            <v-flex sm4>
              <v-text-field
                name="name"
                label="Name"
                type="text"
                class="mr-1"
                v-model="shopQueryParams.name"
              ></v-text-field>
            </v-flex>
            <v-flex sm4>
              <v-btn outline color="primary" @click="onSearchShop">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-flex 12 class="mt-1">
            <v-card>
              <v-data-table
                :headers="headers"
                :items="shopList"
                class="elevation-1"
                :loading="showListLoading"
                :total-items="totalRows"
                :rows-per-page-items="shopRowsPerPageItems"
                :pagination.sync="pagination"
                :must-sort="true"
              >
                <template slot="items" slot-scope="props">
                  <td
                    @click="
                      setShop(props.item.id, props.item.code),
                        (showShopListDialog = !showShopListDialog)
                    "
                  >
                    <a>{{ props.item.name }}</a>
                  </td>
                  <td>{{ props.item.code }}</td>
                  <td>{{ props.item.phoneNo }}</td>
                  <td>{{ props.item.city.name }}</td>
                  <td>{{ props.item.township.name }}</td>
                  <td>{{ props.item.address }}</td>
                  <td>
                    {{
                      props.item.updatedDateInMilliSeconds | formatMsDateTime
                    }}
                  </td>
                  <td>{{ props.item.updatedBy }}</td>
                </template>
              </v-data-table>
            </v-card>
          </v-flex>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!--debit account list dialog -->
    <v-dialog
      v-model="showDebitAccountListDialog"
      scrollable
      max-width="1000px"
    >
      <v-card>
        <v-card-title>
          <v-layout wrap>
            <v-flex sm3>
              <v-text-field
                name="code"
                label="Code"
                type="text"
                class="mr-1"
                v-model="debitAccountQueryParams.code"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-text-field
                name="accName"
                label="Acccount Name"
                type="text"
                class="mr-1"
                v-model="debitAccountQueryParams.accName"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-text-field
                name="accountheadName"
                label="Account Head Name"
                type="text"
                class="mr-1"
                v-model="debitAccountQueryParams.accountheadName"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-btn outline color="primary" @click="onSearchDebitAccount()">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-flex 12 class="mt-1">
            <v-card>
              <v-data-table
                :headers="accountHeader"
                :items="debitAccountList"
                class="elevation-1"
                :loading="showListLoading"
                :total-items="totalAccountRows"
                :rows-per-page-items="debitRowsPerPageItems"
                :pagination.sync="debitAccountPagination"
                :must-sort="true"
              >
                <template slot="items" slot-scope="props">
                  <td
                    @click="
                      setDebitAccount(props.item, selectedIndex),
                        (showDebitAccountListDialog =
                          !showDebitAccountListDialog)
                    "
                  >
                    <a>{{ props.item.code }}</a>
                  </td>
                  <td>{{ props.item.accName }}</td>
                  <td>{{ props.item.accTypeName }}</td>
                  <td>{{ props.item.nature }}</td>
                  <td>{{ props.item.accounthead.accountName }}</td>
                  <td>{{ props.item.parentCode }}</td>
                  <td>
                    {{
                      props.item.updatedDateInMilliSeconds | formatMsDateTime
                    }}
                  </td>
                  <td>{{ props.item.updatedBy }}</td>
                  <td></td>
                </template>
              </v-data-table>
            </v-card>
          </v-flex>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!--credit account list dialog -->
    <v-dialog
      v-model="showCreditAccountListDialog"
      scrollable
      max-width="1000px"
    >
      <v-card>
        <v-card-title>
          <v-layout wrap>
            <v-flex sm3>
              <v-text-field
                name="code"
                label="Code"
                type="text"
                class="mr-1"
                v-model="creditAccountQueryParams.code"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-text-field
                name="accName"
                label="Acccount Name"
                type="text"
                class="mr-1"
                v-model="creditAccountQueryParams.accName"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-text-field
                name="accountheadName"
                label="Account Head Name"
                type="text"
                class="mr-1"
                v-model="creditAccountQueryParams.accountheadName"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-btn outline color="primary" @click="onSearchCreditAccount()">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-flex 12 class="mt-1">
            <v-card>
              <v-data-table
                :headers="accountHeader"
                :items="creditAccountList"
                class="elevation-1"
                :loading="showListLoading"
                :total-items="totalAccountRows"
                :rows-per-page-items="creditRowsPerPageItems"
                :pagination.sync="creditAccountPagination"
                :must-sort="true"
              >
                <template slot="items" slot-scope="props">
                  <td
                    @click="
                      setCreditAccount(props.item, selectedIndex),
                        (showCreditAccountListDialog =
                          !showCreditAccountListDialog)
                    "
                  >
                    <a>{{ props.item.code }}</a>
                  </td>
                  <td>{{ props.item.accName }}</td>
                  <td>{{ props.item.accTypeName }}</td>
                  <td>{{ props.item.nature }}</td>
                  <td>{{ props.item.accounthead.accountName }}</td>
                  <td>{{ props.item.parentCode }}</td>
                  <td>
                    {{
                      props.item.updatedDateInMilliSeconds | formatMsDateTime
                    }}
                  </td>
                  <td>{{ props.item.updatedBy }}</td>
                  <td>{{ props.item.status }}</td>
                  <td></td>
                </template>
              </v-data-table>
            </v-card>
          </v-flex>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- final message dialog -->
    <v-dialog
      v-model="messageDialogBox"
      max-width="500px"
      @keydown.enter="messageDialogBox = false"
    >
      <v-card>
        <v-card-text>
          <v-flex>
            <v-alert type="warning" :value="true">
              <h3>{{ responseError }}</h3>
            </v-alert>
          </v-flex>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" flat @click="messageDialogBox = false"
            >Close</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import {
  GeneralLedger,
  GeneralLedgerAttachment,
  GeneralLedgerDetail,
} from "../../models/model";
import { shopService } from "../../services/shop-service";
import { chartOfAccountService } from "../../services/chart-of-account-service";
import { currencyService } from "../../services/currency-service";
import { generalLedgerService } from "../../services/general-ledger-service";
import { commonService } from "../../services/common-service";
import { GeneralLedgerFormRules } from "../../helpers/validation-rules";

export default {
  name: "GeneralLedgerDetail",
  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),
    valid: true,
    showAutocompleteLoading: false,
    breadcrumbs: [
      {
        text: "Finance",
        disabled: true,
      },
      {
        text: "Ledger Entry Detail",
        disabled: true,
      },
    ],
    selectedIndex: 0,
    shopQueryParams: {
      name: "",
      code: "",
      status: "ACTIVE",
    },
    debitAccountQueryParams: {
      accName: "",
      code: "",
      accountheadName: "",
      isParent: false,
    },
    creditAccountQueryParams: {
      accName: "",
      code: "",
      accountheadName: "",
      isParent: false,
    },
    headers: [
      { text: "Name", align: "left", value: "name" },
      { text: "Code", align: "left", value: "code" },
      { text: "PhoneNo", value: "phoneNo" },
      { text: "City", value: "city" },
      { text: "Township", value: "township" },
      { text: "Address", value: "address" },
      { text: "Updated Date", value: "updatedDate" },
      { text: "Updated By", value: "updatedBy" },
    ],
    accountHeader: [
      { text: "Code", align: "left", value: "code" },
      { text: "Name", value: "accName" },
      { text: "Type", value: "type" },
      { text: "Nature", value: "nature" },
      { text: "Account Head", value: "accountHead.accountName" },
      { text: "Parent Code", value: "accountChild.code" },
      { text: "Updated Date", value: "createdDate" },
      { text: "Updated By", value: "createdBy" },
      { text: "Status", value: "status" },
    ],
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 50,
      sortBy: "name",
      totalItems: 0,
    },
    debitAccountPagination: {
      descending: true,
      page: 1,
      rowsPerPage: 50,
      sortBy: "updatedDate",
      totalItems: 0,
    },
    creditAccountPagination: {
      descending: true,
      page: 1,
      rowsPerPage: 50,
      sortBy: "updatedDate",
      totalItems: 0,
    },
    statusList: [
      { label: "Draft", value: "DRAFT" },
      { label: "Posted", value: "POSTED" },
      { label: "Cancel", value: "CANCEL" },
    ],

    shopRowsPerPageItems: [25, 50, 100],
    debitRowsPerPageItems: [25, 50, 100],
    creditRowsPerPageItems: [25, 50, 100],

    ledgerDate: "",
    status: "",
    shopCode: "",
    debitCodeName: "",
    debitCode: "",
    creditCodeName: "",
    creditCode: "",
    responseError: "",
    fileUrl: "",
    fileName: "",
    totalRows: 0,
    totalAccountRows: 0,
    debitAccountList: [],
    creditAccountList: [],
    shopList: [],
    currencyList: [],
    generalLedgerAttachments: [],
    fileSize: 0,
    files: [],
    showShopListDialog: false,
    showCreditAccountListDialog: false,
    showDebitAccountListDialog: false,
    showListLoading: false,
    saveLoading: false,
    isError: false,
    messageDialogBox: false,
    error: "",
    generalLedger: new GeneralLedger(),
    generalLedgerDetail: new GeneralLedgerDetail(),
    oldGeneralLedger: new GeneralLedger(),
    generalLedgerAttachment: new GeneralLedgerAttachment(),
    rules: new GeneralLedgerFormRules(),
    totalDebitAmount: 0,
    totalCreditAmount: 0,
    decimalFormat: "",
    ledgerByName: "",
  }),

  created() {
    const id = this.$route.params.id;
    if (id == "new") {
      // new user
      this.status = "DRAFT";
      if (this.user.ledgerBy) {
        this.generalLedger.ledgerById = this.user.ledgerBy;
        this.ledgerByName = this.user.ledgerByObj.name;
      }
      this.addDebitAccount();
      this.addCreditAccount();
    } else {
      this.getGeneralLedger(id);
    }

    this.ledgerDate = commonService.formatDate(
      new Date().toISOString().substr(0, 10),
      "YYYY-MM-DD"
    );
    this.getCurrencyList();
    this.decimalFormat = commonService.formatdecimal();
  },

  watch: {
    pagination: {
      handler() {
        this.getActiveShops();
      },
      deep: true,
    },
    creditAccountPagination: {
      handler() {
        this.getCreditAccountList();
      },
      deep: true,
    },
    debitAccountPagination: {
      handler() {
        this.getDebitAccountList();
      },
      deep: true,
    },
  },

  methods: {
    init: function () {
      this.responseError = "";
      this.$refs.file.value = "";
      this.file = "";
    },
    goBack() {
      this.$router.go(-1);
    },

    showShops() {
      this.shopQueryParams.name = "";
      this.shopQueryParams.code = "";
      this.getActiveShops().then(
        (this.showShopListDialog = !this.showShopListDialog)
      );
    },

    getGeneralLedger(id) {
      generalLedgerService
        .getGeneralLedgerDetail(id)
        .then((res) => {
          this.generalLedger = res.data;
          this.status = res.data.status;
          this.fileUrl = res.data.fileUrl;
          this.fileName = res.data.fileName;
          this.generalLedgerAttachments = res.data.generalLedgerAttachments;

          this.ledgerDate = commonService.millisecondToDate(
            this.generalLedger.ledgerDateInMilliSeconds,
            "YYYY-MM-DD"
          );
          this.updatedDate = commonService.formatDate(
            new Date(this.generalLedger.updatedDateInMilliSeconds)
              .toISOString()
              .substr(0, 10),
            "YYYY-MM-DD"
          );
          this.shopCode = res.data.shopCode;
          this.debitCodeName = res.data.debitCodeName;
          this.debitCode = res.data.debitCode;
          this.creditCodeName = res.data.creditCodeName;
          this.creditCode = res.data.creditCode;
          this.ledgerByName = res.data.ledgerByName;
          // deep copy
          this.oldGeneralLedger = JSON.parse(JSON.stringify(res.data));
          this.calculateAmount();
        })
        .catch((err) => {
          console.log(err);
        });
    },

    getActiveShops() {
      this.showListLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";
      return shopService
        .getShopList(
          this.shopQueryParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy + "," + order
        )
        .then((res) => {
          if (res.data) {
            this.shopList = res.data.shopList;
            this.totalRows = res.data.totalElements;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },

    onSearchShop() {
      this.pagination.page = this.pagination.page;
      this.pagination.size = this.pagination.rowsPerPage;
      this.getActiveShops();
    },

    setShop(id, code) {
      this.generalLedger.shopId = id;
      this.shopCode = code;
    },

    calculateAmount() {
      this.totalDebitAmount = 0;
      this.totalCreditAmount = 0;
      this.generalLedger.generalLedgerDetailList.forEach((element) => {
        if (element.accountType == "CREDIT" && element.amount != "")
          this.totalCreditAmount =
            this.totalCreditAmount + parseFloat(element.amount);
        else if (element.accountType == "DEBIT" && element.amount != "")
          this.totalDebitAmount =
            this.totalDebitAmount + parseFloat(element.amount);
      });
    },

    addCreditAccount() {
      // deep copy
      let generalLedgerDetail = JSON.parse(
        JSON.stringify(this.generalLedgerDetail)
      );
      generalLedgerDetail.accountType = "CREDIT";
      this.generalLedger.generalLedgerDetailList.push(generalLedgerDetail);
    },

    addDebitAccount() {
      // deep copy
      let generalLedgerDetail = JSON.parse(
        JSON.stringify(this.generalLedgerDetail)
      );
      generalLedgerDetail.accountType = "DEBIT";
      this.generalLedger.generalLedgerDetailList.push(generalLedgerDetail);
    },

    removeGLDetail(index, generalLedgerDetailId) {
      if (generalLedgerDetailId) {
        if (!this.generalLedger.deleteGeneralLedgerDetailIds) {
          this.generalLedger.deleteGeneralLedgerDetailIds = [];
        }
        this.generalLedger.deleteGeneralLedgerDetailIds.push(
          generalLedgerDetailId
        );
      }
      this.$delete(this.generalLedger.generalLedgerDetailList, index);
      this.calculateAmount();
    },

    showDebitAccountList() {
      this.debitAccountQueryParams.accName = "";
      this.debitAccountQueryParams.code = "";
      this.debitAccountQueryParams.accountheadName = "";
      this.getDebitAccountList().then(
        (this.showDebitAccountListDialog = !this.showDebitAccountListDialog)
      );
    },

    showCreditAccountList() {
      this.creditAccountQueryParams.accName = "";
      this.creditAccountQueryParams.code = "";
      this.creditAccountQueryParams.accountheadName = "";
      this.getCreditAccountList().then(
        (this.showCreditAccountListDialog = !this.showCreditAccountListDialog)
      );
    },

    getDebitAccountList() {
      this.showListLoading = true;
      let order = this.debitAccountPagination.descending ? "desc" : "asc";
      return chartOfAccountService
        .getChartOfAccountList(
          this.debitAccountQueryParams,
          this.debitAccountPagination.page,
          this.debitAccountPagination.rowsPerPage,
          this.debitAccountPagination.sortBy + "," + order
        )
        .then((res) => {
          if (res.data) {
            this.debitAccountList = res.data.chartOfAccountList;
            this.totalAccountRows = res.data.totalElements;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },

    getCreditAccountList() {
      this.showListLoading = true;
      let order = this.creditAccountPagination.descending ? "desc" : "asc";
      return chartOfAccountService
        .getChartOfAccountList(
          this.creditAccountQueryParams,
          this.creditAccountPagination.page,
          this.creditAccountPagination.rowsPerPage,
          this.creditAccountPagination.sortBy + "," + order
        )
        .then((res) => {
          if (res.data) {
            this.creditAccountList = res.data.chartOfAccountList;
            this.totalAccountRows = res.data.totalElements;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },
    setDebitAccount(account, index) {
      this.generalLedger.generalLedgerDetailList[index].accountId = account.id;
      this.generalLedger.generalLedgerDetailList[index].accountName =
        account.accName;
      this.generalLedger.generalLedgerDetailList[index].code = account.code;
    },
    setCreditAccount(account, index) {
      this.generalLedger.generalLedgerDetailList[index].accountId = account.id;
      this.generalLedger.generalLedgerDetailList[index].accountName =
        account.accName;
      this.generalLedger.generalLedgerDetailList[index].code = account.code;
    },
    getCurrencyList() {
      currencyService
        .getAllCurrency()
        .then((res) => {
          this.currencyList = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    onSearchDebitAccount() {
      this.debitAccountPagination.page = this.debitAccountPagination.page;
      this.debitAccountPagination.size =
        this.debitAccountPagination.rowsPerPage;
      this.getDebitAccountList();
    },
    onSearchCreditAccount() {
      this.creditAccountPagination.page = this.creditAccountPagination.page;
      this.creditAccountPagination.size =
        this.creditAccountPagination.rowsPerPage;
      this.getCreditAccountList();
    },

    onSave() {
      let formData = new FormData();
      if (this.$refs.form.validate()) {
        if (this.files) {
          this.saveLoading = true;
          for (var i = 0; i < this.files.length; i++) {
            let file = this.files[i];
            formData.append("file", file);
          }
        }

        this.saveLoading = true;
        this.generalLedger.ledgerDateInMilliSeconds =
          commonService.convertToMilliseconds(this.ledgerDate);
        this.generalLedger.type = "JOURNAL";
        generalLedgerService
          .saveGeneralLedger(this.generalLedger)
          .then((res) => {
            console.log(res);
            this.submitForm(res.data.id);
          })
          .catch((err) => {
            console.log(err);
            if (err.response.data) {
              this.responseError = err.response.data.message;
            }
          })
          .finally(() => {
            this.saveLoading = false;
          });
      }
    },

    submitForm(id) {
      if (this.files) {
        this.saveLoading = true;
        let formData = new FormData();
        for (var i = 0; i < this.files.length; i++) {
          let file = this.files[i];
          console.log(file);
          formData.append("file", file);
        }
        generalLedgerService
          .saveFiles(formData, id)
          .then((res) => {
            this.goBack();
            this.done();
            console.log(res.data);
          })
          .catch((err) => {
            if (err.response) {
              this.responseError = err.response.data.message;
            }
          })
          .finally(() => {
            this.saveLoading = false;
          });
      }
    },

    onChangeFileUpload(e) {
      this.responseError = "";
      var size = 0;
      this.files = e.target.files;
      if (this.files) {
        for (var i = 0; i < this.files.length; i++) {
          size += this.files[i].size / 1024 / 1024;
        }
      }
      if (size > 30) {
        this.responseError =
          "Upload file size exceeds the maximun upload size!";
      }
    },

    clear() {
      this.$refs.form.resetValidation();
      if (!this.generalLedger.id) {
        this.generalLedger = new GeneralLedger();
        this.debitCode = "";
        this.creditCode = "";
        this.debitCodeName = "";
        this.creditCodeName = "";
        this.shopCode = "";
      }
      this.isError = true;
      this.error = "Credit Account and Debit Account must be different.";
    },

    removeFile(index, fileId) {
      if (fileId) {
        // add delete stock in id
        if (!this.generalLedger.deleteGeneralLedgerAttachmentIds) {
          this.generalLedger.deleteGeneralLedgerAttachmentIds = [];
        }
        this.generalLedger.deleteGeneralLedgerAttachmentIds.push(fileId);
      }
      this.$delete(this.generalLedger.generalLedgerAttachments, index);
    },

    downloadFile(file) {
      generalLedgerService
        .downloadFile(file.id)
        .then(commonService.downloadE)
        .catch((err) => {
          console.error(err);
          if (err.response.data) {
            this.responseError = err.response.data.message;
          }
        });
    },
  },
};
</script>